import React from "react";
import Star from "../icons/star";
import { kebabCase } from "../../utilities/helper";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";
import Breadcrumb from "../breadcrumb";

const TitleSubheadingBanner = (bannerClass, bannerData, blockIndex, forceH1 = false, breadcrumbSettings) => {
  const { id, backgroundColor, title, bodyCopy } = bannerData;
  const heading = title ? (
    forceH1 ? <><Breadcrumb settings={breadcrumbSettings} /><h1 className="xl-heading">{title}</h1></> : <h2 className="xl-heading">{title}</h2>
  ) : "";
  const copy = bodyCopy ? <p className="h3">{bodyCopy}</p> : "";

  const Anchor = bannerData?.anchor ?? kebabCase(title) ?? id;
  useCollectAnchorLinks(title, bannerData?.anchor, blockIndex);

  return (
    <div className={`banner bg-${backgroundColor} ${bannerClass}`} id={Anchor}>
      <div className="banner--wrapper">
        <div className="banner--wrapper__column">
          <div className="content">
            {heading}
            {copy}
          </div>
          <div className="star--wrapper">
            <Star />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitleSubheadingBanner;
